import React from "react";
import { withTranslation } from "react-i18next";
import { Container, Row, Col, Button } from "reactstrap";

const ScannerApiContact = ({ t }) => {
  return (
    <Container fluid className="p-0" style={{ height: "100vh", overflow: "hidden" }}>
      <Row noGutters className="h-100">
        <Col className="d-flex flex-column justify-content-center align-items-center">
          <h2>{t("phish_guard_url_checker.contact.title")}</h2>
            {t("phish_guard_url_checker.contact.contact_message")}
        </Col>
      </Row>
    </Container>
  );
};

export default withTranslation()(ScannerApiContact);
